import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";

import Attr from './container/Attr';

import './assets/css/index.css';
import './assets/css/font.css';
import './assets/css/ReactToastify.min.css';
import { store } from './sotre/redux/store';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Attr />
      </Provider>
    </BrowserRouter>
    <ToastContainer />
  </React.StrictMode>
);